function FloatingContact() {
  return (
    <a className="floating-contact" href="tel:+996123456789" aria-label="Позвонить Chinatao">
      Call
    </a>
  );
}

export default FloatingContact;
